import React, { useState, useEffect } from "react";
import { getAllPages, deletePage, getAllSearchPages } from "../../api/api";
import Listloader from "../loader/content";
import InfiniteScroll from "react-infinite-scroll-component";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import "./search.css";
import { Link } from "react-router-dom";
import ElementModal from "../modal/elementModal";
import { getElementRefDetail } from "../../api/api";
import { UserLang } from "../../store/userStore";
import PageModals from "../modal/modal2";

const Pages = (props) => {
  let pager = "element";
  const [pageModalShow, setPageModalShow] = useState(false);
  const [delModalShow, setDelModalShow] = useState(false);
  const [allPage, setallPage] = useState([]);
  const [elemId, setElemId] = useState([]);
  const [pageNum, setPageNum] = useState(0);
  const [hasHigh, sethasHigh] = useState(true);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [search, setSearch] = useState(false);
  const [listload, setListload] = useState(true);
  const lan = UserLang.useState((s) => s.lan);

  useEffect(() => {
    const getPage = async () => {
      setLoading(true);
      try {
        const appl = await getAllPages(10, 0);

        const pages = appl.data.pages;

        const imageCount = appl.data.count;

        setallPage(pages);
        setPageNum(imageCount);
        if (imageCount === appl.data.pages.length) {
          sethasHigh(false);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getPage();
  }, []);

  const handleDelete = async (event, id, index) => {
    if (id !== undefined && id !== "") {
      /* eslint-disable no-unused-vars */
      const result = await getElementRefDetail(id).then(
        (result) => {
          setElemId(result.data);
          setListload(false);
          if (result.data.length > 0) {
            setDelModalShow(true);
          } else {
            setDelModalShow(false);
            const removeId = index;
            event.preventDefault();
            const items = Array.from(allPage);
            items.splice(removeId, 1);
            setallPage(items);
            try {
              /* eslint-disable no-unused-vars */
              const result = deletePage(id);
              /* eslint-disable no-unused-vars */
              toastr.success("Successfully Deleted", "Success");
            } catch (error) {
              toastr.error("Error in deleting the Image", "Error");
            }
          }
        },
        (error) => {
          setElemId(null);
          setListload(false);
        }
      );
    } else {
      setListload(false);
      toastr.error("Delete Id is Missing", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  const fetchData = async () => {
    if (
      (!search && (query === "" || query !== "")) ||
      (search && query === "")
    ) {
      const length = allPage.length;
      try {
        const appl = await getAllPages(length + 10, length);

        const pages = appl.data.pages;

        const imageCount = appl.data.count;

        setPageNum(imageCount);
        const newArray = [...allPage, ...pages];

        setallPage(newArray);
        setPageNum(imageCount);
        if (pageNum === allPage.length) {
          sethasHigh(false);
        }
      } catch (error) {}
    } else {
      const length = allPage.length;
      try {
        const appl = await getAllSearchPages(length + 10, length, query);

        const pages = appl.data.pages;

        const imageCount = appl.data.count;

        setPageNum(imageCount);
        const newArray = [...allPage, ...pages];

        setallPage(newArray);
        setPageNum(imageCount);
        if (pageNum === allPage.length) {
          sethasHigh(false);
        }
      } catch (error) {}
    }
  };

  const getSearchResult = async () => {
    setLoading(true);

    try {
      const appl = await getAllSearchPages(10, 0, query);
      const pages = appl.data.pages;

      const imageCount = appl.data.count;

      setallPage(pages);
      setPageNum(imageCount);
      if (imageCount === appl.data.pages.length) {
        sethasHigh(false);
      }
      if (appl.data.pages.length < appl.data.limit) {
        sethasHigh(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getPageStart = async () => {
    sethasHigh(true);
    setLoading(true);
    try {
      const appl = await getAllPages(10, 0);

      const pages = appl.data.pages;

      const imageCount = appl.data.count;

      setallPage(pages);
      setPageNum(imageCount);
      if (imageCount === appl.data.pages.length) {
        sethasHigh(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card ">
                <div className="card-header filter">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Pages
                  </h3>

                  <ul
                    className={
                      lan === "rtl"
                        ? "float-left navbar-nav ml-auto "
                        : "float-right navbar-nav ml-auto "
                    }
                  >
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-widget="navbar-search"
                        href="#!"
                        role="button"
                        onClick={(event) => {
                          event.preventDefault();
                          setSearch(!search);
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </a>
                      <div
                        className={
                          search
                            ? "navbar-search-block"
                            : "navbar-search-block none"
                        }
                      >
                        <form
                          className="form-inline"
                          onSubmit={(event) => {
                            event.preventDefault();
                            getSearchResult();
                          }}
                        >
                          <div className="input-group input-group-sm">
                            <input
                              className="form-control form-control-navbar"
                              type="search"
                              placeholder="Search"
                              aria-label="Search"
                              value={query}
                              onChange={(event) => setQuery(event.target.value)}
                            />
                            <div className="input-group-append">
                              <button className="btn btn-navbar" type="submit">
                                <i className="fas fa-search"></i>
                              </button>
                              <button
                                className="btn btn-navbar"
                                type="button"
                                data-widget="navbar-search"
                                onClick={(event) => {
                                  setSearch(false);
                                  getPageStart();
                                }}
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#!"
                        className="nav-link btn btn-light"
                        role="button"
                        onClick={() => setPageModalShow(true)}
                      >
                        <i className="fas fa-plus"></i> New
                      </a>
                    </li>
                  </ul>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-sm-12">
                            <InfiniteScroll
                              dataLength={allPage.length}
                              hasMore={hasHigh}
                              loader={<Listloader></Listloader>}
                              next={fetchData}
                            >
                              <table
                                id="appadmin"
                                className="table table-bordered table-hover dataTable dtr-inline"
                                role="grid"
                                aria-describedby="example2_info"
                                dir={lan === "rtl" ? "rtl" : "ltr"}
                              >
                                <thead>
                                  <tr role="row">
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      <label
                                        className={
                                          lan === "rtl"
                                            ? "float-right"
                                            : "float-left"
                                        }
                                      >
                                        Name
                                      </label>
                                    </th>
                                    <th>
                                      <label
                                        className={
                                          lan === "rtl"
                                            ? "float-right"
                                            : "float-left"
                                        }
                                      >
                                        Status
                                      </label>
                                    </th>
                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      <label
                                        className={
                                          lan === "rtl"
                                            ? "float-right"
                                            : "float-left"
                                        }
                                      >
                                        Delete
                                      </label>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {allPage.map((person, index) => (
                                    <tr role="row" className="even" key={index}>
                                      <td
                                        className="dtr-control sorting_1"
                                        tabIndex={0}
                                      >
                                        <Link
                                          to={
                                            person.pageType === "normalPage"
                                              ? "/page/" + person._id
                                              : "/" +
                                                person.pageType.toLowerCase() +
                                                "/" +
                                                person._id
                                          }
                                          style={{ display: "block" }}
                                          className={
                                            lan === "rtl"
                                              ? "float-right"
                                              : "float-left"
                                          }
                                        >
                                          {person.referenceName}
                                        </Link>
                                        <br></br>
                                        <span
                                          className={
                                            lan === "rtl"
                                              ? "float-right text-muted"
                                              : "float-left text-muted"
                                          }
                                        >
                                          {person.pageType}
                                        </span>
                                      </td>
                                      <td>
                                        <label
                                          className={
                                            lan === "rtl"
                                              ? person.draftStatus &&
                                                person.publishStatus
                                                ? "float-right badge badge-success"
                                                : "float-right badge badge-danger"
                                              : person.draftStatus &&
                                                  person.publishStatus
                                                ? "float-left badge badge-success"
                                                : "float-left badge badge-danger"
                                          }
                                        >
                                          {person.draftStatus &&
                                          person.publishStatus
                                            ? "Published"
                                            : "Draft"}
                                        </label>
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className={
                                            lan === "rtl"
                                              ? "float-right btn btn-light"
                                              : "float-left btn btn-light"
                                          }
                                          onClick={(event) =>
                                            handleDelete(
                                              event,
                                              person._id,
                                              index
                                            )
                                          }
                                        >
                                          <i className="fa fa-trash"></i> Delete
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </InfiniteScroll>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
        <PageModals
          show={pageModalShow}
          onHide={() => setPageModalShow(false)}
          {...props}
        />
        <ElementModal
          show={delModalShow}
          onHide={() => setDelModalShow(false)}
          elemid={!listload ? elemId : null}
          paged={pager === "page" ? 1 : 0}
        ></ElementModal>
      </section>
    );
  }
};

export default Pages;
